//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        FSIInboundUnmatchreport: [],
        searchRequest: {},
      },

      mutations: {
        updateFSIInboundUnmatchRpt(state, FSIInboundUnmatchrpt) {
          state.FSIInboundUnmatchreport = FSIInboundUnmatchrpt;
        },
        updateSearchFSIInboundUnmatchRptRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async FSIInboundUnmatchList({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))

          if (requestToSend.logCreateDate.startDate)
          {
            requestToSend.logCreateDate.startDate = dateFormat.getLocalDateOnly(requestToSend.logCreateDate.startDate);
          }

          if (requestToSend.logCreateDate.endDate)
          {
            requestToSend.logCreateDate.endDate = dateFormat.getLocalDateEnd(requestToSend.logCreateDate.endDate);
          }
          else{
            requestToSend.logCreateDate.endDate = dateFormat.getLocalDateEnd(requestToSend.logCreateDate.startDate);
          }

          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/fsi/WebSearchFSIContainerUpdateLog', requestToSend);
          const result = await newAPIPost('/api/w/fsi/WebSearchFSIContainerUpdateLog', requestToSend);
          commit('updateSearchFSIInboundUnmatchRptRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          return commit('updateFSIInboundUnmatchRpt', result);
                },
      },

      getters: {
        getFSIInboundUnmatchReport: state => state.FSIInboundUnmatchreport,
      },
}
